import React from 'react'
import { FeaturedCardDiv } from './styles'
import SelectProductButton from '../SelectProductButton'
import { Text } from '../../styles/Components'
import { gsColors as c } from '../../styles/Variables'
import { useMarketContext } from '../../components/MarketContext'

const formatInvalidText = (invalidMarketNames) => {
  if (invalidMarketNames.length === 1) {
    return invalidMarketNames.join('')
  }

  let invalidMarketText = invalidMarketNames
  invalidMarketText[invalidMarketText.length - 1] = `and ${invalidMarketText[invalidMarketText.length - 1]}`
  return invalidMarketText.join(', ')
}

const FeaturedCard = ({ featuredItem }) => {
  const { markets } = useMarketContext()

  const validMarketIds = featuredItem.markets.map(market => market.id)

  const invalidMarketNames = markets
    .filter(market => !validMarketIds.includes(market.id))
    .map(invalidMarket => invalidMarket.name)
    .filter(name => !!name)

  const invalidMarketsText = formatInvalidText(invalidMarketNames)

  // separates string from paragraphs and second part of array is bullet points
  const desc = featuredItem.description.split(':') // leftover paragraph (only visible on client app)
  const membershipPoints = desc[1].split('\n')

  return (
    <FeaturedCardDiv>
      <div className='price-info'>
        <div className='featured-item-price'>
          <Text weight={700} variant='medium'>${featuredItem.price}/month</Text>
        </div>

        <Text color={c.cobalt} weight={600}>{featuredItem.discountLabel}</Text>
      </div>

      <div className='membership-perks'>
        <Text variant='medium' weight={600}>Membership Includes</Text>
        {membershipPoints && (
          <ul>
            {/* removes empty new line from bullet points */}
            {membershipPoints.map((p, i) => p && <li key={i}>{p}</li>)}
          </ul>
        )}
      </div>

      <div className='featured-card-footer'>
        <div className='footer-content'>
          <div>
            <SelectProductButton
              fromPath="membership"
              product={featuredItem}
              featured 
            />
          </div>
          <Text color={c.meredithGrey} fontSize={14}>
            Membership valid in all markets except {invalidMarketsText}.
            Tax & gratuity added at checkout.            
            Membership credits expire after 60 days.
          </Text>
        </div>
      </div>

    </FeaturedCardDiv>
  )
}

export default FeaturedCard
